import $ from 'jquery';

function logErrorMessage(msg) {
  console.error('[Hash.js] The hash passed in to update location is not valid');
  console.error(`[Hash.js] ${msg}`);
}

function isValid(hash) {
  if ('string' !== typeof hash) {
    logErrorMessage('Hash has to be a string');
    return;
  }

  if (!hash.length) {
    logErrorMessage('Hash is empty');
    return;
  }

  return true;
}

function update(hash) {
  if (!isValid(hash)) { return; }

  const destinationElement = $( document.getElementById(hash.substring(1)) );

  if (history.pushState) {
    history.pushState({}, '', hash);
  } else {
    destinationElement.removeAttr('id');
    location.hash = hash;
    destinationElement.attr('id', hash.substring(1));
  }
}

export default { update }
